import React, { useState } from 'react';
import { useDispatch } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import DateTimeFunctions from '../../../../Classes/dateTimeFunctions';
import { alterSnackbar } from '../../../../data/actions/siteActions';
import axios from '../../../../data/http/axios';

export default function AutomationOptionContact({ AutomationId, contact, history, step, nextStep, refresh = () => { } }) {
    const dispatch = useDispatch()
    const [removing, setRemoving] = useState(false)
    const [deleting, setDeleting] = useState(false)
    const [skipping, setSkipping] = useState(false)
    const [isSkipping, setIsSkipping] = useState(false)

    const click = e => {
        e.preventDefault();
        e.stopPropagation();
        return false
    }

    const skip = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setSkipping(true)
        return false
    }

    const doSkip = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSkipping(true)
        await axios.put('/automation/' + AutomationId + '/step/' + step.guid, {
            ids: [contact.AutomationQueues[0].id],
            action: 'move',
            destination: nextStep.guid
        })
        refresh()
        clear()
        return false
    }

    const exit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setRemoving(true)
        return false
    }

    const remove = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDeleting(true)
        const res = await axios.delete('/automation/' + AutomationId + '/subscriber/' + contact.id)
        if (!res.data.success) dispatch(alterSnackbar(true, 'Contact already removed from Automation'))
        else dispatch(alterSnackbar(true, 'Contact removed from Automation'))
        refresh()
        clear()
        return false
    }

    const clear = () => {
        setSkipping(false)
        setIsSkipping(false)
        setDeleting(false)
        setRemoving(false)
    }

    const queueItem = contact.AutomationQueues[0]
    const logItem = history[history.length - 1] || { createdAt: queueItem.createdAt }

    const canSkip = (step.type === 'wait' || step.type === 'delay') && nextStep

    return (
        <div className="automationOptionContact" onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            return false
        }}>
            <div className="automationOptionContactDetails">
                {!removing && !skipping && <>
                    <div className="mar-b5">
                        <div className="text-heavy">Date Entered:</div>
                        <div>{DateTimeFunctions.formatDateTime(logItem.createdAt)}</div>
                    </div>
                    <div>
                        <div className="text-heavy">Next Step:</div>
                        <div>{DateTimeFunctions.formatDateTime(queueItem.ActionDate)}</div>
                    </div>
                    <div className="mar-t15">
                        <Button className="button-sml button-primary mar-b10" disabled={!canSkip} onClick={skip}>Skip Step</Button>
                        <Button className="button-sml button-red" onClick={exit}>Exit Automation</Button>
                    </div>
                </>}
                {removing && <div>
                    <div className="mar-b5 text-heavy">Remove Contact from this Automation?</div>
                    <div className="mar-b10">They will be able to rejoin this Automation at a later date.</div>
                    <Button disabled={deleting} onClick={remove} className="button-red button-sml mar-b10">Yes, Remove</Button>
                    <Button disabled={deleting} className="button-sml" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setRemoving(false)
                        return false
                    }}>No, Cancel</Button>
                    {deleting && <LoadingIcons className="mar-t20" />}
                </div>}
                {skipping && <div>
                    <div className="mar-b15 text-heavy">Move Contact to Next Step?</div>
                    <div className="mar-b10">This will skip any goal checks as well</div>
                    <Button disabled={isSkipping} onClick={doSkip} className="button-primary button-sml mar-b10">Yes, Skip</Button>
                    <Button disabled={isSkipping} className="button-sml" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setSkipping(false)
                        return false
                    }}>No, Cancel</Button>
                    {isSkipping && <LoadingIcons className="mar-t20" />}
                </div>}
            </div>
        </div>
    )
}